import { Component, inject, signal, WritableSignal } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs';

import { DemoFieldData, demoFields } from '@demo/data/demo-cipo-fields';
import { AddFieldComponent } from '@demo/demo-cipo-fields/add-field/add-field.component';
import { CipoControlComponent } from '@shared/components/fields/cipo-control/cipo-control.component';
import { CipoFieldConfig, CipoFieldTypes } from '@shared/components/fields/common';
import { CipoFormModule } from '@shared/modules';

@Component({
  selector: 'app-demo-cipo-fields',
  imports: [CipoFormModule, CipoControlComponent],
  templateUrl: './demo-cipo-fields.component.html',
})
export class DemoCipoFieldsComponent {
  dialog = inject(MatDialog);

  /* Updated this to demonstrate how the cipo-fields work with basic formControls and separate fieldData */
  form = new FormGroup({});
  FIELD_TYPES = CipoFieldTypes;

  fieldDataMap: Record<string, WritableSignal<CipoFieldConfig>> = {};

  constructor() {
    demoFields.forEach(field => this.addFormControl(field));
  }

  logForm() {
    console.log(this.form.value);
  }

  changeRequired(checked: boolean) {
    Object.values(this.fieldDataMap).forEach(fieldData => {
      fieldData.update(fd => ({ ...fd, required: checked }));
    });
  }

  changeReadonly(checked: boolean) {
    Object.values(this.fieldDataMap).forEach(fieldData => {
      fieldData.update(fd => ({ ...fd, readonly: checked }));
    });
  }

  addField() {
    this.dialog
      .open(AddFieldComponent, {
        panelClass: ['cipo-dialog', 'classic'],
        width: '60vw',
        data: 'test',
      })
      .afterClosed()
      .pipe(filter(result => !!result))
      .subscribe((result: DemoFieldData) => this.addFormControl(result));
  }

  addFormControl(controlData: DemoFieldData) {
    const { name, defaultValue, ...props } = controlData;
    const control = new FormControl(defaultValue);
    this.fieldDataMap[name] = signal(props);
    this.form.addControl(name, control);
  }
}
